/**
 * Compose part of the URL that's used to access an event.
 * @param eventId - the purely numerical one (like 14351000), not the UUID
 * @returns {string}
 */
export function getEventUrl(eventId) {
  return `EventDetailsReportPlace:/${eventId}`;
}

export const FormVisibility = {
  HIDDEN: 'HIDDEN',
  VISIBLE: 'VISIBLE',
};

export const matchCustomProp = prop => prop.match(/^CustomProperty\.(.*)/);

export const CUSTOM_PROPERTY_PREFIX = 'CustomProperty.';

export const convertCustomProps = (params = {}) => {
  const customProps = Object.keys(params).filter(param =>
    matchCustomProp(param),
  );

  // If there are no custom params, do nothing
  if (!customProps.length) {
    return params;
  }

  // Rebuild the params object, omitting custom props
  const newParams = Object.keys(params)
    .filter(prop => !matchCustomProp(prop))
    .reduce(
      (obj, staticParam) => ({
        ...obj,
        [staticParam]: params[staticParam],
      }),
      {},
    );

  // Add custom props to the object with the following format:
  // propertyNames=param1,param2&propertyValues=value1,value2
  const { customPropNames, customPropValues } = customProps.reduce(
    (obj, prop) => {
      const match = matchCustomProp(prop);
      if (!params[prop]) return obj;

      const customName = match[1];
      const customPropFull = params[prop];
      // Handle internal commas by adding each as a seperate property searches:
      customPropFull.split(',').forEach(propertyValuePart => {
        obj.customPropNames.push(customName);
        obj.customPropValues.push(propertyValuePart.trim());
      });

      return obj;
    },
    { customPropNames: [], customPropValues: [] },
  );

  if (!customPropNames.length || !customPropValues.length) {
    return newParams;
  }

  newParams.propertyNames = customPropNames.join(',');
  newParams.propertyValues = customPropValues.join(',');

  return newParams;
};
